<template>
  <div class="main-reset">
    <div id="video">
      <video autoplay loop muted playsinline width="100%"><source src="@/assets/jaffel_backdrop.mp4" type="video/mp4"></video>
    </div>
    <div class="reset-container frosted">
      <img alt="Clink Logo" src="../assets/images/clink-wide-text.png">
      <h2>Neues Passwort</h2>
      <p v-if="msg" :class="{ error: isError, success: !isError }">{{msg}}</p>
      
      <div v-if="!success" class="reset-form">
        <form v-on:submit.prevent="submit">
          <table class="login-fields">
            <tbody>
              <tr>
                <td><label for="password">Neues Passwort</label></td>
                <td><input type="password" id="password" v-model="passwords.new" placeholder="Mind. 6 Zeichen"></td>
              </tr>
              <tr>
                <td><label for="password-repeat">Wiederholen</label></td>
                <td><input type="password" id="password-repeat" v-model="passwords.repeat"></td>
              </tr>
            </tbody> 
          </table>
          <div class="buttons">
            <button type="submit" class="login" :class="{disabled_loading: submitting}">Speichern</button>
            <router-link to="/login" class="to-login">Abbrechen</router-link>
          </div>
        </form>
      </div>
      <div v-else class="success-message">
        <p>Dein Passwort wurde erfolgreich geändert.</p>
        <div class="buttons">
          <router-link to="/login" class="login-btn">Zum Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';

export default {
  name: 'ResetPasswordView',
  data() {
    return {
      token: null,
      passwords: {
        new: '',
        repeat: ''
      },
      msg: null,
      isError: false,
      submitting: false,
      success: false
    }
  },
  created() {
    this.token = this.$route.query.token;
    if (!this.token) {
      this.msg = "Ungültiger oder fehlender Token.";
      this.isError = true;
    }
  },
  methods: {
    async submit() {
      if (this.submitting) return;
      this.msg = null;
      this.isError = false;

      if (this.passwords.new.length < 6) {
        this.msg = "Das Passwort muss mindestens 6 Zeichen lang sein.";
        this.isError = true;
        return;
      }
      if (this.passwords.new !== this.passwords.repeat) {
        this.msg = "Die Passwörter stimmen nicht überein.";
        this.isError = true;
        return;
      }

      this.submitting = true;
      try {
        const result = await AuthService.resetPassword({
          token: this.token,
          newPassword: this.passwords.new
        });
        if (result.success) {
          this.success = true;
          this.msg = "Passwort erfolgreich zurückgesetzt.";
        }
      } catch (e) {
        this.msg = e.response?.data?.msg || "Fehler beim Zurücksetzen des Passworts.";
        this.isError = true;
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>

<style scoped>
.main-reset {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: var(--background);
  overflow: hidden;
}

#video:before {
  content:"";
  position: absolute;
  top:0;
  right:0;
  left:0;
  bottom:0;
  z-index:1;
  background: var(--lighten-bg);
}

#video {
  left: 0%;
  top: 0%;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  filter: blur(8px);
  display: flex;
}

#video video {
  object-fit: cover;
}

.reset-container {
  width: 90%;
  max-width: 400px;
  padding: 30px;
  text-align: center;
  box-sizing: border-box;
}

img {
  width: 200px;
  margin-bottom: 20px;
}

h2 {
  margin-bottom: 10px;
  font-size: 1.4rem;
}

.login-fields {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 15px;
}

.login-fields td {
  display: block;
  width: 100%;
}

label {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 5px;
  text-align: left;
  color: var(--secondary-color);
}

input {
  width: 100%;
  padding: 15px;
  border-radius: var(--radius-m);
  background: var(--background-secondary);
  border: none;
  font-size: 1.1rem;
  color: var(--primary-color);
  box-sizing: border-box;
}

input:focus {
  outline: 2px solid var(--primary-color);
  background: #fff;
}

.buttons {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

button.login, .login-btn {
  background: var(--primary-color);
  color: white;
  padding: 18px;
  border-radius: var(--radius-l);
  font-weight: 600;
  font-size: 1.1rem;
  text-decoration: none;
  display: block;
  border: none;
  cursor: pointer;
  width: 100%;
}

.to-login {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 1rem;
  padding: 10px;
}

.error { color: var(--warning); }
.success { color: var(--success); }

.disabled_loading::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.6);
  pointer-events: none;
  border-radius: var(--radius-l);
}
</style>
